import React, { useState, useEffect, useRef } from 'react'
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  FormGroup,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Chip,
  IconButton,
  Tooltip,
  InputAdornment,
  OutlinedInput,
  ListItemText,
  CircularProgress,
  Menu,
  Popper,
  ClickAwayListener,
  Paper,
  useMediaQuery,
  FormLabel
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import AddIcon from '@mui/icons-material/Add'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import DeleteIcon from '@mui/icons-material/Delete'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'
import serverData from '../../../../api/ServerData'
import {
  formatNumber,
  isEmpty,
  showToast,
  validateEmail,
  validateZipCode
} from '../../../../utils/AppHelper'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { logoutUser } from '../../../../actions/loginActions'
import { JobTypes, currencySymbol } from '../../../../utils/AppConstants'
import CustomModal from '../../../../commonComponents/CustomModal'
import JobPostPreviewModal from './JobPostPreviewModal'
import AppButton from '../../../../commonComponents/AppButton'
import TextEditor from '../../../../commonComponents/TextEditor'
import { TextBold, TextRegular } from '../../../../commonComponents/TextStyling'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
}

export default function PostNewJob ({ user }) {
  var theme = useTheme()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [jobUpdateLoading, setJobUpdateLoading] = useState(false)
  const [jobPostLoading, setJobPostLoading] = useState(false)
  const [jobDraftLoading, setJobDraftLoading] = useState(false)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const location = useLocation()
  const data = location.state || {}

  useEffect(() => {
    if (data?.isEdit || data?.isAdd) {
      setJobTitle(data?.item?.jobTitle)
      setTotalPositions(data?.item?.totalPositions)
      setJobFunction(data?.item?.jobFunction)
      // setCountry(data?.item?.country)
      // setZipCode(data?.item?.zipCode.toString())
      setCity(data?.item?.city)
      // setState(data?.item?.state)
      setWorkLocationType(data?.item?.workLocationType)
      // setRelocationAssistance(data?.item?.relocationAssistance)
      // setJobRelocationAssistanceText(data?.item?.jobRelocationAssistanceText)
      // setWorkLocationInfo(data?.item?.workLocationInfo)
      setJobType(parseInt(data?.item?.jobType))
      // setContractDuration(data?.item?.contractDuration || '')
      // setDurationType(data?.item?.durationType)
      // setDesiredStartDate(
      //   data?.item?.desiredStartDate
      //     ? dayjs(data?.item?.desiredStartDate)
      //     : null
      // )
      // setSupplierLimit(data?.item?.supplierLimit || '')
      // setJobBenefits(data?.item?.jobBenefits)
      // setCity(data?.item?.city)
      // setEducationLevel(data?.item?.educationLevel)
      setExperienceLevel(data?.item?.experienceLevel)
      // setRequiredExpYear(data?.item?.requiredExpYear)
      // setRequiredExpMonth(data?.item?.requiredExpMonth)
      // setVisaSponsorship(data?.item?.visaSponsorship)
      setJobDescription(data?.item?.jobDescription)
      setSkillRequired(data?.item?.skillRequired.split(','))
      // setPreScreenQuesJobType(data?.item?.preScreenQuestions)

      // setJobCompensationAmountMin(data?.item?.jobCompensationAmountMin)
      // setJobCompensationAmountMax(data?.item?.jobCompensationAmountMax)
      // setJobCompensationText(data?.item?.jobCompensationText)
      // setRejectionPeriod(data?.item?.rejectionPeriod)
      // setRejectionReasons(
      //   data?.item?.rejectionReason.map(e => {
      //     e.isChecked = true
      //     return e
      //   })
      // )
      // setJobOrderNumber(data?.item?.jobOrderNumber)
      setEmailShow(!isEmpty(data?.item?.emailCc))
      setEmailCc(
        isEmpty(data?.item?.emailCc) ? [] : data?.item?.emailCc.split(',')
      )
      setJobDeadline(data?.item?.jobDeadline)
      setBudget(data?.item?.budget)
    }
  }, [])

  const [jobTitle, setJobTitle] = useState('')
  const [totalPositions, setTotalPositions] = useState('1')
  const [jobFunction, setJobFunction] = useState('')
  const [country, setCountry] = useState('')
  const [zipCode, setZipCode] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [workLocationType, setWorkLocationType] = useState('')
  const [workLocationInfo, setWorkLocationInfo] = useState('')
  const [relocationAssistance, setRelocationAssistance] = useState(0)
  const [jobRelocationAssistanceText, setJobRelocationAssistanceText] =
    useState('')
  const [jobType, setJobType] = useState('')
  const [jobCompensationAmountMin, setJobCompensationAmountMin] = useState(0)
  const [jobCompensationAmountMax, setJobCompensationAmountMax] = useState(0)
  const [jobCompensationText, setJobCompensationText] = useState('')
  const [contractDuration, setContractDuration] = useState('')
  const [durationType, setDurationType] = useState('month')
  const [desiredStartDate, setDesiredStartDate] = useState(null)
  const [supplierLimit, setSupplierLimit] = useState('')
  const [jobBenefits, setJobBenefits] = useState('')
  const [rejectionPeriod, setRejectionPeriod] = useState('')

  //   For Sourcing only
  const [rejectionReasons, setRejectionReasons] = useState([])

  const [editRejection, setEditRejection] = useState('')
  const [viewRejection, setViewRejection] = useState(null)
  const [editRejectionModal, setEditRejectionModal] = useState({
    show: false,
    item: null
  })
  const [educationLevel, setEducationLevel] = useState('')
  const [experienceLevel, setExperienceLevel] = useState('')
  const [requiredExpYear, setRequiredExpYear] = useState(0)
  const [requiredExpMonth, setRequiredExpMonth] = useState(0)
  // const [visaSponsorship, setVisaSponsorship] = useState('no')
  const [jobDescription, setJobDescription] = useState('')
  const [skillRequired, setSkillRequired] = useState([])
  const [jobDeadline, setJobDeadline] = useState('')
  const [budget, setBudget] = useState('')
  const [subEmployers, setSubEmployers] = useState([])

  const [emailShow, setEmailShow] = useState(false)
  const [inputEmail, setInputEmail] = useState('')
  const [subEmployersList, setSubEmployersList] = useState([])

  const [emailCc, setEmailCc] = useState([])
  const [jobOrderNumber, setJobOrderNumber] = useState('')

  const [preScreenQuesJobType, setPreScreenQuesJobType] = useState([])

  const [dropDownValues, setDorpDownValues] = useState({})
  const [modal, setModal] = useState({
    open: false,
    title: '',
    message: '',
    onClose: null
  })

  const [previewModal, setPreviewModal] = useState({
    open: false
  })

  const [zipCodeLoading, setZipCodeLoading] = useState(false)

  const [inputSkills, setInputSkills] = useState('')

  const [skillSuggestions, setSkillSuggestions] = useState([])
  const containerRef = useRef(null)
  const [openPopper, setOpenPopper] = useState(false)
  const [popperClick, setPopperClick] = useState(false)

  const getSkillSuggestions = skill_name => {
    serverData.getSkillSuggestions(
      { skill_name },
      result => {
        if (result.status) {
          setSkillSuggestions(result.response)
          if (result.response.length > 0) {
            setOpenPopper(true)
          }
        }
      },
      error => {
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  useEffect(() => {
    // if (!user.isProfileCompleted) {
    //   setModal({
    //     open: true,
    //     title: 'Profile incomplete',
    //     message: `Please update your profile to start posting jobs. ${
    //       user.isSubEmployer ? '\nAsk your account manager to do so.' : ''
    //     }`,
    //     disableOverlay: true,
    //     onClose: () => {
    //       if (user.isSubEmployer) {
    //         navigate('/employer/dashboard')
    //       } else {
    //         navigate('/employer/editprofile')
    //       }
    //     }
    //   })
    // }
    if (!data?.isEdit) {
      // serverData.getPreQuestions(
      //   { jobTypeId: jobType },
      //   result => {
      //     if (result.status) {
      //       setPreScreenQuesJobType(result.response)
      //     }
      //   },
      //   error => {
      //     if (error.status === 401) {
      //       dispatch(logoutUser(navigate)) // eslint-disable-next-line
      //     }
      //   }
      // )
      // if (jobType === JobTypes.Sourcing) {
      //   serverData.getRejectedReasons(
      //     {},
      //     result => {
      //       if (result.status) {
      //         setRejectionReasons(result.response)
      //       }
      //     },
      //     error => {
      //       if (error.status === 401) {
      //         dispatch(logoutUser(navigate)) // eslint-disable-next-line
      //       }
      //     }
      //   )
      // } else {
      // }
    }
  }, [jobType])

  const handleEnterSkills = (event, skill) => {
    if (event.key === 'Enter' || event.type === 'click') {
      var error = {}
      var trimmedSkills = ''
      if (event.type === 'click') {
        trimmedSkills = skill
      } else {
        trimmedSkills = inputSkills.trim()
      }

      if (trimmedSkills && !skillRequired.includes(trimmedSkills)) {
        setSkillRequired([...skillRequired, trimmedSkills])
        setInputSkills('')
      } else {
        showToast('Skill is already added.')
        setFormError(error)
      }
    }
  }
  const handleDeleteSkill = index => {
    setSkillRequired(skillRequired.filter((_, i) => i !== index))
  }

  useEffect(function () {
    serverData.getJobPostDropDownValues(
      {},
      result => {
        if (result.status) {
          setDorpDownValues(result.response)
        }
      },
      error => {
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
    getSubEmployers()
  }, [])

  function getSubEmployers () {
    serverData.getSubEmployers(
      {},
      result => {
        if (result.status) {
          let { response } = result
          setSubEmployersList(response)
          let subEmp = []
          if (data?.isEdit) {
            var arr = data.item.subEmployers.split(',')
            subEmp = response.filter(e => arr.includes(e.id.toString()))
          }

          if (user.isSubEmployer) {
            var subUser = response.find(e => e.email === user.email)
            if (subUser) {
              var i = subEmp.indexOf(subUser)
              if (i === -1) {
                subUser.disabled = true
                subEmp.push(subUser)
              } else {
                subEmp[i].disabled = true
              }
            }
          }

          setSubEmployers(subEmp)
        }
      },
      error => {
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  const closeEditModal = () => {
    setEditRejectionModal({ show: false, item: null })
    setEditRejection('')
  }

  function getStateAndCityByZipcode () {
    setZipCodeLoading(true)
    serverData.getStateAndCityByZipcode(
      { zipCode },
      result => {
        if (result.status) {
          let { city, state } = result.response
          setState(state)
          setCity(city)
        }
        setZipCodeLoading(false)
      },
      error => {
        setZipCodeLoading(false)

        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  const [formError, setFormError] = useState({})

  const validateForm = () => {
    const error = {}

    if (isEmpty(jobTitle)) {
      error.jobTitle = 'Please enter job title.'
    }
    if (isEmpty(totalPositions)) {
      error.totalPositions = 'Please select number of position'
    }
    if (isEmpty(jobFunction)) {
      error.jobFunction = 'Please select job function'
    }
    // if (isEmpty(country)) {
    //   error.country = 'Please select the country'
    // }
    // if (isEmpty(zipCode)) {
    //   error.zipCode = 'Please enter Zip code'
    // } else if (!validateZipCode(zipCode)) {
    //   error.zipCode = 'Zip code should be min 4 and max 11 digits.'
    // }

    // if (isEmpty(state)) {
    //   error.state = 'Please enter state'
    // }

    if (isEmpty(city)) {
      error.city = 'Please enter city'
    }

    if (isEmpty(workLocationType)) {
      error.workLocationType = 'Please select work location type'
    }

    // if (isEmpty(relocationAssistance) || relocationAssistance === 0) {
    //   error.relocationAssistance = 'Please select relocation assistance'
    // }

    if (isEmpty(jobType)) {
      error.jobType = 'Please select job type'
    }

    // if (jobType === JobTypes.Contract) {
    //   if (isEmpty(contractDuration)) {
    //     error.contractDuration = 'Please enter contract duration'
    //   }
    //   // }
    //   if (isEmpty(desiredStartDate)) {
    //     error.desiredStartDate = 'Please select desired start date'
    //   }
    //   if (isEmpty(supplierLimit)) {
    //     error.supplierLimit = 'Please enter candidate submission limit'
    //   }
    // }

    // if (jobType === JobTypes.Sourcing) {
    //   for (let index = 0; index < rejectionReasons.length; index++) {
    //     const element = rejectionReasons[index]
    //     if (element.isUserDefined && isEmpty(element.reason)) {
    //       if (!error.hasOwnProperty('rejectionReasons')) {
    //         error.rejectionReasons = {}
    //       }
    //       error.rejectionReasons[index] = {
    //         reason: 'Please enter rejection reason'
    //       }
    //     }
    //   }
    // }

    // if (jobCompensationAmountMin !== 0 || jobCompensationAmountMax !== 0) {
    //   if (jobCompensationAmountMin === 0) {
    //     error.jobCompensation = 'Please select first field'
    //   }

    //   if (jobCompensationAmountMax <= jobCompensationAmountMin) {
    //     error.jobCompensation =
    //       'Please ensure that the compensation value in the first field is less than the value in the second field'
    //   }
    // }

    // if (isEmpty(educationLevel)) {
    //   error.educationLevel = 'Please select education level'
    // }
    if (isEmpty(experienceLevel)) {
      error.experienceLevel = 'Please select job-experience level'
    }
    if (isEmpty(jobDescription)) {
      error.jobDescription = 'Please enter job description.'
    }
    if (skillRequired.length === 0) {
      error.skillRequired = 'Press enter to add skills.'
    }

    // if (preScreenQuesJobType.length > 0) {
    //   for (let index = 0; index < preScreenQuesJobType.length; index++) {
    //     const element = preScreenQuesJobType[index]
    //     if (isEmpty(element.question)) {
    //       if (!error.hasOwnProperty('preScreenQuesJobType')) {
    //         error.preScreenQuesJobType = {}
    //       }
    //       error.preScreenQuesJobType[index] = {
    //         question: 'Please enter a question'
    //       }
    //     }
    //     if (element.type !== 'textfield') {
    //       for (
    //         let optionIndex = 0;
    //         optionIndex < element.options.length;
    //         optionIndex++
    //       ) {
    //         const option = element.options[optionIndex]
    //         if (isEmpty(option.name)) {
    //           if (!error.hasOwnProperty('preScreenQuesJobType')) {
    //             error.preScreenQuesJobType = {}
    //           }
    //           if (!error.preScreenQuesJobType.hasOwnProperty(index)) {
    //             error.preScreenQuesJobType[index] = {}
    //           }
    //           if (
    //             !error.preScreenQuesJobType[index].hasOwnProperty('options')
    //           ) {
    //             error.preScreenQuesJobType[index]['options'] = {}
    //           }
    //           error.preScreenQuesJobType[index]['options'][optionIndex] =
    //             'Please enter a option'
    //         }
    //       }
    //     }
    //   }
    // }

    // if (emailShow && emailCc.length === 0) {
    //   error.emailCc = 'Press enter to add email.'
    // }

    // if (subEmployers.length === 0) {
    //   error.subEmployers = "Please select sub-employer's name."
    // }
    setFormError(error)
    return Object.keys(error).length === 0
  }
  const handleSubmitJob = async isDraft => {
    if (validateForm()) {
      if (isDraft) {
        setJobDraftLoading(true)
      } else if (data?.isEdit) {
        setJobUpdateLoading(true)
      } else {
        setJobPostLoading(true)
      }
      var body = {
        jobTitle,
        totalPositions,
        jobFunction,
        // country,
        // zipCode,
        city,
        // state,
        workLocationType,
        // workLocationInfo,
        // relocationAssistance,
        // jobRelocationAssistanceText,
        jobType,
        // jobCompensationAmountMin,
        // jobCompensationAmountMax,
        // jobCompensationText,
        // contractDuration,
        // durationType,
        // desiredStartDate: desiredStartDate
        //   ? dayjs(desiredStartDate).format('YYYY-MM-DD hh:mm:ss')
        //   : '',
        // supplierLimit,
        // jobBenefits,
        // rejectionPeriod,
        // rejectionReasons: rejectionReasons.filter(e => e.isChecked),
        // educationLevel,
        experienceLevel,
        // requiredExpYear,
        // requiredExpMonth,
        budget,
        jobDeadline,
        // visaSponsorship,
        jobDescription,
        skillRequired,
        // preScreenQuesJobType,
        subEmployers: subEmployers?.map(e => e.id)
        // emailCc
        // jobOrderNumber
      }
      if (data?.isEdit) {
        body.jobId = data?.item?.jobId
        await serverData.editPostedJob(
          body,
          data => {
            if (data.status) {
              setModal({
                open: true,
                title: 'Congratulations',
                message: data.message,
                onClose: () => {
                  navigate('/employer/managejob')
                }
              })
            } else {
              showToast(data.message)
            }
            setJobUpdateLoading(false)
          },
          error => {
            showToast(error.statusText)
            setJobUpdateLoading(false)
          }
        )
      } else {
        if (isDraft) {
          body.status = 'draft'
        }
        console.log('***6***', body)
        await serverData.postJob(
          body,

          data => {
            if (data.status) {
              setModal({
                open: true,
                title: 'Congratulations',
                message: data.message,
                onClose: () => {
                  navigate('/employer/managejob')
                }
              })
            } else {
              showToast(data.message)
            }
            setJobDraftLoading(false)
            setJobPostLoading(false)
          },
          error => {
            showToast(error.statusText)
            setJobDraftLoading(false)
            setJobPostLoading(false)
          }
        )
      }
    }
  }

  function deleteQuestionFromLibrary (item, index) {
    serverData.deleteQuestionFromLibrary(
      { id: item.id },
      data => {
        if (data.status) {
          const questions = [...preScreenQuesJobType]
          questions.splice(index, 1)
          setPreScreenQuesJobType(questions)
        } else {
          showToast(data.message)
        }
      },
      error => {}
    )
  }

  function fromCompensationValues () {
    const resultArray = [
      { value: 25000 },
      { value: 50000 },
      { value: 75000 },
      { value: 100000 },
      { value: 125000 },
      { value: 150000 },
      { value: 175000 },
      { value: 200000 },
      { value: 225000 },
      { value: 250000 },
      { value: 275000 },
      { value: 500000 },
      { value: 750000 },
      { value: 1000000 },
      { value: 1500000 },
      { value: 2000000 },
      { value: 2500000 },
      { value: 5000000 },
      { value: 10000000 },
      { value: 15000000 },
      { value: 20000000 },
      { value: 25000000 },
      { value: 30000000 }
    ]

    return resultArray
  }

  function toCompensationValue () {
    let startValue = jobCompensationAmountMin

    let resultArray = []
    for (let i = 0; i < 20; i++) {
      startValue += 25000
      resultArray.push({ value: startValue })
    }

    return resultArray
  }
  const [step, setStep] = useState(1)
  const totalSteps = 5

  const mainSection = {
    display: 'flex',
    // flexDirection: 'row',
    justifyContent: 'space-between'
    // flexWrap: 'wrap',
  }

  const leftSide = {
    marginBottom: '24px'
  }

  const rightSide = {
    // flex: '1 1 45%'
  }

  // const input = {
  //   width: '100%',
  //   padding: '12px',
  //   border: '1px solid #ccc',
  //   borderRadius: '6px',
  //   marginBottom: '24px'
  // };

  const exampleList = {
    paddingLeft: '20px',
    color: '#555',
    fontSize: '14px',
    lineHeight: '1.6'
  }

  const progressBarContainer = {
    height: '4px',
    width: '100%',
    backgroundColor: '#DDDDDD',
    // borderRadius: '8px',
    marginTop: '32px',
    marginBottom: '32px'
  }

  const progressBarFill = {
    height: '100%',
    width: `${(step / totalSteps) * 100}%`,
    backgroundColor: '#000',
    borderRadius: '8px',
    transition: 'width 0.3s ease'
  }

  const renderStepContent = () => {
    switch (step) {
      case 1:
        return (
          <Grid container direction='column'>
            <Grid item xs={12}>
              <FormControl fullWidth error={formError.jobTitle}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px'
                  }}
                >
                  Job title *
                </TextRegular>
                <TextField
                  required
                  fullWidth
                  value={jobTitle}
                  error={formError.jobTitle}
                  helperText={formError.jobTitle}
                  onChange={e => {
                    var { value } = e.target
                    if (value.length < 60) {
                      setJobTitle(e.target.value)
                    }
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth error={formError.jobType}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px',
                    marginTop: '20px'
                  }}
                >
                  Job type *
                </TextRegular>
                <Select
                  required
                  id='jobType'
                  value={jobType}
                  onChange={event => setJobType(event.target.value)}
                >
                  {dropDownValues?.jobTypes?.map(item => (
                    <MenuItem required value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{formError.jobType}</FormHelperText>
              </FormControl>
            </Grid>
            <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>
              Example titles
            </p>
            <ul style={exampleList}>
              <li>React Native Developer For FinTech MVP</li>
              <li>Full-Stack Engineer to Scale a B2B SAAS</li>
              <li>Talent Acqusition Partner for early-stage startup</li>
              <li>Grapic Designer for social media and creatives</li>
              <li>Backend Developer for API integrations</li>
            </ul>
          </Grid>
        )
      case 2:
        return (
          <>
            <FormControl fullWidth error={formError.city}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px'
                }}
              >
                City
              </TextRegular>
              <TextField
                value={city}
                onChange={e => {
                  const input = e.target.value
                    .replace(/[!@#$%^&*(),.?":{}|<>]/, '')
                    .replace(/\d/g, '')
                  if (input.length < 50) {
                    setCity(input)
                  }
                }}
                fullWidth
                error={formError.city}
                helperText={formError.city}
              />
            </FormControl>
            <FormControl fullWidth error={formError.workLocationType}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px',
                  marginTop: '20px'
                }}
              >
                Work Location Type *
              </TextRegular>
              <Select
                labelId='workLocationType-label'
                value={workLocationType}
                onChange={event => setWorkLocationType(event.target.value)}
              >
                {dropDownValues?.workLocationTypes?.map(item => (
                  <MenuItem required value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{formError.workLocationType}</FormHelperText>
            </FormControl>

            <FormControl fullWidth error={formError.skillRequired}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px',
                  marginTop: '20px'
                }}
              >
                Skills *
              </TextRegular>
              <Box>
                <TextField
                  placeholder='Press enter to enter multiple skills'
                  value={inputSkills}
                  onChange={event => {
                    const { value } = event.target
                    setInputSkills(value)
                    if (value) {
                      getSkillSuggestions(value)
                    }
                  }}
                  onKeyDownCapture={event => {
                    setPopperClick(true)
                    handleEnterSkills(event, event.target.value)
                  }}
                  InputProps={{
                    disableUnderline: true
                  }}
                  sx={{
                    width: '100%'
                  }}
                  ref={containerRef}
                  onFocus={() => {
                    setOpenPopper(true)
                    setPopperClick(true)
                  }}
                  onBlur={() => {
                    if (popperClick) {
                      setOpenPopper(true)
                    } else {
                      setOpenPopper(false)
                    }
                  }}
                />
                {skillRequired?.map((skill, index) => (
                  <Chip
                    key={index}
                    label={skill}
                    onDelete={() => handleDeleteSkill(index)}
                    style={{
                      margin: '8px'
                    }}
                    sx={{
                      '& .MuiChip-deleteIcon': {
                        color: `${theme.palette.primary.main}`
                      }
                    }}
                  />
                ))}
                <Popper
                  open={
                    skillSuggestions.length > 0 && openPopper && popperClick
                  }
                  anchorEl={containerRef.current}
                  placement='bottom-start'
                >
                  <ClickAwayListener
                    onClickAway={event => {
                      if (!containerRef.current.contains(event.target)) {
                        setPopperClick(false)
                        setOpenPopper(false)
                      }
                    }}
                  >
                    <Paper
                      sx={{
                        padding: '0px',
                        width: containerRef?.current?.clientWidth
                      }}
                    >
                      <Grid container>
                        <Grid item xs={12}>
                          <ul
                            style={{
                              listStyleType: 'none',
                              padding: '0px',
                              margin: '0px'
                            }}
                          >
                            {skillSuggestions.map((skill, index) => (
                              <>
                                <Button
                                  style={{
                                    color: theme.palette.text.secondary,
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'left',
                                    textTransform: 'none'
                                  }}
                                  onClick={event => {
                                    handleEnterSkills(event, skill.skill_name)
                                  }}
                                >
                                  <li
                                    key={index}
                                    style={{
                                      padding: '10px',
                                      lineHeight: '1rem'
                                    }}
                                  >
                                    {skill.skill_name}
                                  </li>
                                </Button>
                                {index < skillSuggestions.length - 1 && (
                                  <Divider style={{ width: '100%' }} />
                                )}
                              </>
                            ))}
                          </ul>
                        </Grid>
                      </Grid>
                    </Paper>
                  </ClickAwayListener>
                </Popper>
              </Box>
              <FormHelperText>{formError.skillRequired}</FormHelperText>
            </FormControl>
          </>
        )
      case 3:
        return (
          <>
            <FormControl fullWidth error={formError.experienceLevel}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px'
                }}
              >
                Experience Level *
              </TextRegular>
              <Select
                required
                id='experienceLevel'
                value={experienceLevel}
                onChange={e => setExperienceLevel(e.target.value)}
              >
                {dropDownValues?.experienceLevel?.map(item => (
                  <MenuItem required value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{formError.experienceLevel}</FormHelperText>
            </FormControl>
            <FormControl fullWidth error={formError.jobFunction}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px',
                  marginTop: '20px'
                }}
              >
                Job Function *
              </TextRegular>
              <Select
                required
                id='jobFunction'
                value={jobFunction}
                onChange={event => setJobFunction(event.target.value)}
              >
                {dropDownValues?.jobFunctions?.map(item => (
                  <MenuItem required value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{formError.jobFunction}</FormHelperText>
            </FormControl>

            <FormControl fullWidth error={formError.totalPositions}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px',
                  marginTop: '20px'
                }}
              >
                Total number of positions *
              </TextRegular>
              <Select
                id='no-of-position'
                value={totalPositions}
                error={formError.totalPositions}
                onChange={event => setTotalPositions(event.target.value)}
                required
              >
                {Array.from({ length: 100 }, (_, i) => i + 0).map(number => (
                  <MenuItem value={number}>{number}</MenuItem>
                ))}
              </Select>
              <FormHelperText>{formError.totalPositions}</FormHelperText>
            </FormControl>
          </>
        )
      case 4:
        return (
          <Grid container direction='column'>
            {/* <FormControl fullWidth error={formError.jobDescription}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px'
                }}
              >
                Job Description *
              </TextRegular>
              <TextEditor 
                getter={jobDescription}
                setter={setJobDescription}
                placeholder={'Copy and paste the job description here.'}
              />

              <FormHelperText>{formError.jobDescription}</FormHelperText>
            </FormControl> */}
            <Grid item xs={12} sx={{ marginBottom: '20px' }}>
              <FormControl fullWidth error={formError.jobDescription}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px'
                  }}
                >
                  Job Description *
                </TextRegular>
                <div
                  style={{
                    backgroundColor: '#ffffff'
                  }}
                >
                  <TextEditor
                    getter={jobDescription}
                    setter={setJobDescription}
                    placeholder='Copy and paste the job description here.'
                    style={{ backgroundColor: '#ffffff' }}
                  />
                </div>

                <FormHelperText>{formError.jobDescription}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px'
                }}
              >
                Deadline *
              </TextRegular>

              <FormControl fullWidth error={formError.jobDeadline}>
                {/* <InputLabel id='deadline-label'>Deadline</InputLabel> */}
                <Select
                  // labelId="deadline-label"
                  id='job-deadline'
                  value={jobDeadline}
                  onChange={e => setJobDeadline(e.target.value)}
                  displayEmpty
                  size='small'
                >
                  <MenuItem value='' disabled></MenuItem>
                  <MenuItem value='7_days'>7 Days</MenuItem>
                  <MenuItem value='14_days'>14 Days</MenuItem>
                  <MenuItem value='30_days'>30 Days</MenuItem>
                  <MenuItem value='custom'>Custom</MenuItem>
                </Select>
                <FormHelperText>{formError.jobDeadline}</FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
        )
      case 5:
        return (
          <>
            <TextRegular
              style={{
                color: theme.palette.text.secondary,
                marginBottom: '6px'
              }}
            >
              Budget *
            </TextRegular>

            <div>
              <FormControl fullWidth error={formError.budget}>
                <TextField
                  type='text'
                  placeholder='Enter budget here'
                  value={budget}
                  onChange={e => setBudget(e.target.value)}
                  fullWidth
                  size='small'
                />
                <FormHelperText>{formError.budget}</FormHelperText>
              </FormControl>{' '}
            </div>
          </>
        )
      default:
        return null
    }
  }
  const getStepHeading = step => {
    switch (step) {
      case 1:
        return 'Let’s start with a strong title.'
      case 2:
        return 'Where will they work, and what should they know?'
      case 3:
        return 'One role or many, junior or pro  we’ve got you.'
      case 4:
        return 'Describe the position clearly'
      case 5:
        return 'Set your budget and post'
      default:
        return 'Let’s continue building your job post'
    }
  }

  const getStepSubText = step => {
    switch (step) {
      case 1:
        return 'This is the first thing our AI and recruiters will see. Make it clear and specific it leads the way.'
      case 2:
        return 'Add key skills to help us match you with the right recruiters and candidates.'
      case 3:
        return 'Add key skills to help us match you with the right recruiters and candidates.'
      case 4:
        return 'Share job description and deadline.'
      case 5:
        return 'Finalize the budget and post your job.'
      default:
        return 'This helps your job post stand out to the right candidates.'
    }
  }

  const validateStep = () => {
    const errors = {}

    switch (step) {
      case 1:
        if (!jobTitle?.trim()) errors.jobTitle = 'Job title is required'
        if (!jobType) errors.jobType = 'Job type is required'
        break

      case 2:
        if (!city?.trim()) errors.city = 'Please enter city'
        if (!workLocationType)
          errors.workLocationType = 'Work location type is required'
        if (!Array.isArray(skillRequired) || skillRequired.length === 0) {
          errors.skillRequired = 'Press enter to add skills.'
        }
        break

      case 3:
        if (!experienceLevel)
          errors.experienceLevel = 'Experience level is required'
        if (!totalPositions) errors.totalPositions = 'Position is required'
        if (!jobFunction || isEmpty(jobFunction)) {
          errors.jobFunction = 'Please select job function'
        }
        break

      case 4:
        if (!jobDescription?.trim())
          errors.jobDescription = 'Job description is required'
        if (!jobDeadline) errors.jobDeadline = 'Deadline must be selected'
        break

      case 5:
        if (!budget) errors.budget = 'Budget is required'
        break

      default:
        break
    }

    setFormError(errors)
    return Object.keys(errors).length === 0
  }

  return (
    <Grid>
      {/* <Grid item xs={10} style={{ padding: '0px' }}> */}
      <Grid
        container
        style={{
          display: 'flex',
          justifyContent: 'center'
          // height: isMobile? '55':'calc(100vh - 325px)'
        }}
      >
        <Grid container style={mainSection}>
          {/* Left Side */}
          <Grid item xs={12} md={4} style={leftSide}>
            <Grid>
              <TextRegular sx={{ color: '#888', fontSize: '14px' }}>
                {step}/5 Job Post
              </TextRegular>
            </Grid>
            <Grid sx={{ margin: '20px 0 30px' }}>
              <TextBold
                sx={{
                  fontSize: isMobile ? '20px' : '28px',
                  lineHeight: 'normal'
                }}
              >
                {getStepHeading(step)}
              </TextBold>
            </Grid>
            <TextRegular>{getStepSubText(step)}.</TextRegular>
          </Grid>

          <Grid item md={2}></Grid>
          {/* Right Side */}
          <Grid item xs={12} md={6} style={rightSide}>
            {renderStepContent()}
          </Grid>
        </Grid>
      </Grid>

      {/* Progress Bar */}
      <div style={progressBarContainer}>
        <div style={progressBarFill}></div>
      </div>
      {/* Buttons */}
      <Grid
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        {step > 1 && (
          <AppButton
            variant='contained'
            onClick={() => setStep(step - 1)}
            style={{
              backgroundColor: '#ccc',
              color: '#000',
              width: 'fit-content'
            }}
            name='Back'
          />
        )}

        {step < totalSteps ? (
          <AppButton
            variant='contained'
            onClick={() => {
              if (validateStep()) {
                setStep(step + 1)
              }
            }}
            name='  Next'
            style={{ width: 'fit-content' }}
          />
        ) : (
          <>
            {!data?.isEdit ? (
              <AppButton
                variant='contained'
                name={'Save and post'}
                style={{ width: 'fit-content' }}
                disabled={false}
                loading={jobPostLoading}
                onClick={() => handleSubmitJob(false)}
              />
            ) : (
              <Grid container style={{ justifyContent: 'flex-end' }}>
                <Grid>
                  <AppButton
                    variant='contained'
                    name={'Update'}
                    disabled={false}
                    loading={jobUpdateLoading}
                    onClick={() => handleSubmitJob()}
                  />
                </Grid>
                <Grid style={{ marginLeft: '10px' }}>
                  <Button
                    variant='contained'
                    style={{ textTransform: 'none' }}
                    onClick={() => {
                      navigate('/employer/managejob')
                    }}
                  >
                    Go Back
                  </Button>
                </Grid>
              </Grid>
            )}
          </>
        )}
      </Grid>

      {/* OLD code commented here */}
      <Grid item xs={12} style={{ display: 'none' }}>
        <TextBold style={{ fontSize: '30px' }}>Post a Job</TextBold>
      </Grid>
      {/* <Grid item xs={12} style={{ padding: '0px' }}>
        <Divider />
      </Grid> */}

      <Grid container spacing={3} style={{ display: 'none' }}>
        <Grid item xs={6}>
          <FormControl fullWidth error={formError.jobTitle}>
            <TextRegular
              style={{
                color: theme.palette.text.secondary,
                marginBottom: '6px'
              }}
            >
              Job title *
            </TextRegular>
            <TextField
              required
              fullWidth
              value={jobTitle}
              error={formError.jobTitle}
              helperText={formError.jobTitle}
              onChange={e => {
                var { value } = e.target
                if (value.length < 60) {
                  setJobTitle(e.target.value)
                }
              }}
            />
          </FormControl>
        </Grid>

        <Grid item xs={6} style={{ display: 'none' }}>
          <FormControl fullWidth error={formError.totalPositions}>
            <TextRegular
              style={{
                color: theme.palette.text.secondary,
                marginBottom: '6px'
              }}
            >
              Total number of positions *
            </TextRegular>
            <Select
              id='no-of-position'
              value={totalPositions}
              error={formError.totalPositions}
              onChange={event => setTotalPositions(event.target.value)}
              required
            >
              {Array.from({ length: 100 }, (_, i) => i + 1).map(number => (
                <MenuItem value={number}>{number}</MenuItem>
              ))}
            </Select>
            <FormHelperText>{formError.totalPositions}</FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={6} style={{ display: 'none' }}>
          <FormControl fullWidth error={formError.jobFunction}>
            <TextRegular
              style={{
                color: theme.palette.text.secondary,
                marginBottom: '6px'
              }}
            >
              Job Function *
            </TextRegular>
            <Select
              required
              id='jobFunction'
              value={jobFunction}
              onChange={event => setJobFunction(event.target.value)}
            >
              {dropDownValues?.jobFunctions?.map(item => (
                <MenuItem required value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{formError.jobFunction}</FormHelperText>
          </FormControl>
        </Grid>

        {/* <Grid item xs={6}>
              <FormControl fullWidth error={formError.country}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px'
                  }}
                >
                  Country *
                </TextRegular>
                <Select
                  required
                  id='Country'
                  value={country}
                  onChange={event => setCountry(event.target.value)}
                >
                  {dropDownValues?.countries?.map(item => (
                    <MenuItem required value={item.iso}>
                      {item.nicename}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{formError.country}</FormHelperText>
              </FormControl>
            </Grid> */}
        {/* 
            <Grid item xs={6}>
              <FormControl fullWidth error={formError.zipCode}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px'
                  }}
                >
                  Zip Code *
                </TextRegular>
                <TextField
                  required
                  value={zipCode}
                  error={formError.zipCode}
                  helperText={formError.zipCode}
                  onChange={e => {
                    const input = e.target.value.replace(/\D/g, '')
                    if (input.length < 12) {
                      setZipCode(input)
                    }
                  }}
                  onBlur={() => {
                    if (zipCode.length > 3) {
                      getStateAndCityByZipcode()
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        {zipCodeLoading && <CircularProgress size={24} />}
                      </InputAdornment>
                    )
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth error={formError.city}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px'
                  }}
                >
                  City
                </TextRegular>
                <TextField
                  value={city}
                  onChange={e => {
                    const input = e.target.value
                      .replace(/[!@#$%^&*(),.?":{}|<>]/, '')
                      .replace(/\d/g, '')
                    if (input.length < 50) {
                      setCity(input)
                    }
                  }}
                  fullWidth
                  error={formError.city}
                  helperText={formError.city}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth error={formError.state}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px'
                  }}
                >
                  State
                </TextRegular>
                <TextField
                  value={state}
                  onChange={e => {
                    const input = e.target.value
                      .replace(/[!@#$%^&*(),.?":{}|<>]/, '')
                      .replace(/\d/g, '')
                    if (input.length < 30) {
                      setState(input)
                    }
                  }}
                  fullWidth
                  error={formError.state}
                  helperText={formError.state}
                />
              </FormControl>
            </Grid> */}

        <Grid item xs={6} style={{ display: 'none' }}>
          <FormControl fullWidth error={formError.workLocationType}>
            <TextRegular
              style={{
                color: theme.palette.text.secondary,
                marginBottom: '6px'
              }}
            >
              Work Location Type *
            </TextRegular>
            <Select
              labelId='workLocationType-label'
              value={workLocationType}
              onChange={event => setWorkLocationType(event.target.value)}
            >
              {dropDownValues?.workLocationTypes?.map(item => (
                <MenuItem required value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{formError.workLocationType}</FormHelperText>
          </FormControl>

          {/* <TextField
                fullWidth
                value={workLocationInfo}
                onChange={e => {
                  const input = e.target.value.replace(
                    /[!@#$%^&*(),.?":{}|<>]/,
                    ''
                  )
                  if (input.length < 100) {
                    setWorkLocationInfo(input)
                  }
                }}
                sx={{
                  marginTop: '10px'
                }}
                size='small'
                placeholder='Additional work location information'
              /> */}
        </Grid>

        {/* <Grid item xs={6}>
              <FormControl fullWidth error={formError.relocationAssistance}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px'
                  }}
                >
                  Relocation assistance *
                </TextRegular>
                <Select
                  id='relocationAssistance'
                  value={relocationAssistance || ''}
                  onChange={event =>
                    setRelocationAssistance(event.target.value)
                  }
                >
                  {dropDownValues?.relocationAssistance?.map(item => (
                    <MenuItem required value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {formError.relocationAssistance}
                </FormHelperText>
              </FormControl>

              <TextField
                fullWidth
                value={jobRelocationAssistanceText}
                onChange={e => {
                  const input = e.target.value.replace(
                    /[!@#$%^&*(),.?":{}|<>]/,
                    ''
                  )
                  if (input.length < 100) {
                    setJobRelocationAssistanceText(input)
                  }
                }}
                sx={{
                  marginTop: '10px'
                }}
                size='small'
                placeholder='Additional relocation assistance information'
              />
            </Grid> */}

        <Grid
          item
          xs={12}
          style={{ margin: '32px 0px 8px', paddingTop: '0px' }}
        >
          <Divider />
        </Grid>

        <Grid item xs={6} style={{ display: 'none' }}>
          <FormControl fullWidth error={formError.jobType}>
            <TextRegular
              style={{
                color: theme.palette.text.secondary,
                marginBottom: '6px'
              }}
            >
              Job type *
            </TextRegular>
            <Select
              required
              id='jobType'
              value={jobType}
              onChange={event => setJobType(event.target.value)}
            >
              {dropDownValues?.jobTypes?.map(item => (
                <MenuItem required value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{formError.jobType}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} style={{ display: 'none' }}>
          {jobType === JobTypes.Contract && (
            <Grid container spacing={3}>
              <Grid item xs={6} style={{ display: 'flex' }}>
                <FormControl
                  error={formError.contractDuration}
                  style={{ marginRight: '24px' }}
                >
                  <TextRegular
                    style={{
                      color: theme.palette.text.secondary,
                      marginBottom: '6px'
                    }}
                  >
                    Duration *
                  </TextRegular>
                  <TextField
                    required
                    error={formError.contractDuration}
                    helperText={formError.contractDuration}
                    value={contractDuration}
                    onChange={e => setContractDuration(e.target.value)}
                    sx={{
                      width: '12rem'
                    }}
                  />
                </FormControl>
                <FormControl
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'end',
                    marginBottom: '3px'
                  }}
                >
                  <Select
                    required
                    id='durationType'
                    value={durationType}
                    onChange={e => setDurationType(e.target.value)}
                    sx={{
                      width: '12rem'
                    }}
                  >
                    <MenuItem required value={'month'}>
                      Months
                    </MenuItem>
                    <MenuItem required value={'year'}>
                      Year
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6} style={{ display: 'none' }}>
                <FormControl fullWidth error={formError.desiredStartDate}>
                  <TextRegular
                    style={{
                      color: theme.palette.text.secondary,
                      marginBottom: '6px'
                    }}
                  >
                    Desired start date *
                  </TextRegular>
                  <DatePicker
                    value={desiredStartDate}
                    onChange={date => {
                      if (date) {
                        // setDesiredStartDate(dayjs(date).format('MM/DD/YYYY'))
                        setDesiredStartDate(dayjs(date))
                      }
                    }}
                    renderInput={params => (
                      <TextField
                        sx={{ width: '100%' }}
                        error={formError?.desiredStartDate}
                        helperText={formError?.desiredStartDate}
                        {...params}
                      />
                    )}
                  />

                  <FormHelperText>{formError.desiredStartDate}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={6} style={{ display: 'none' }}>
                <FormControl fullWidth error={formError.supplierLimit}>
                  <TextRegular
                    style={{
                      color: theme.palette.text.secondary,
                      marginBottom: '6px'
                    }}
                  >
                    Candidate submission limit per supplier *
                  </TextRegular>
                  <TextField
                    required
                    fullWidth
                    value={supplierLimit}
                    error={formError.supplierLimit}
                    helperText={formError.supplierLimit}
                    onChange={e => {
                      const input = e.target.value.replace(/\D/g, '')
                      if (input.length < 5) {
                        setSupplierLimit(input)
                      }
                    }}
                    sx={{
                      width: '100%'
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={6} style={{ display: 'none' }}>
                <FormControl fullWidth style={{ marginRight: '16px' }}>
                  <TextRegular
                    style={{
                      color: theme.palette.text.secondary,
                      marginBottom: '6px'
                    }}
                  >
                    Additional Compensation *
                  </TextRegular>
                  <TextField
                    value={jobBenefits}
                    onChange={e => {
                      var { value } = e.target
                      if (value.length < 100) {
                        setJobBenefits(e.target.value)
                      }
                    }}
                    sx={{
                      width: '100%',
                      marginRight: '10px'
                    }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          )}
          {(jobType === JobTypes.DirectHire ||
            jobType === JobTypes.PartTime ||
            jobType === JobTypes.SourceAndScreen ||
            jobType === '') && (
            <Grid xs={6} container>
              <Grid item xs={12}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary
                  }}
                >
                  Annual Compensation
                </TextRegular>
              </Grid>

              <Grid item xs={6} style={{ marginTop: '10px', paddingRight: 24 }}>
                <FormControl fullWidth>
                  <InputLabel id='From'>From</InputLabel>
                  <Select
                    label='From'
                    label-id='From'
                    value={jobCompensationAmountMin || ''}
                    onChange={e => setJobCompensationAmountMin(e.target.value)}
                  >
                    {fromCompensationValues().map(item => (
                      <MenuItem required key={item?.value} value={item?.value}>
                        {currencySymbol} {formatNumber(parseInt(item?.value))}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  display: 'none',
                  marginTop: '10px',
                  paddingRight: 14
                }}
              >
                <FormControl error={formError.jobCompensation} fullWidth>
                  <InputLabel id='To'>To</InputLabel>
                  <Select
                    required
                    id='To'
                    label='To'
                    label-id='To'
                    value={jobCompensationAmountMax || ''}
                    onChange={e => setJobCompensationAmountMax(e.target.value)}
                  >
                    {toCompensationValue().map(item => (
                      <MenuItem required key={item?.value} value={item?.value}>
                        {currencySymbol} {formatNumber(parseInt(item?.value))}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{formError.jobCompensation}</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12} style={{ display: 'none' }}>
                <TextField
                  placeholder='Additional Compensation'
                  value={jobCompensationText}
                  onChange={e => {
                    const input = e.target.value.replace(/\D/g, '')
                    if (input.length < 100) {
                      setJobCompensationText(input)
                    }
                  }}
                  sx={{
                    width: '100%',
                    marginTop: '10px',
                    paddingRight: '13px'
                  }}
                  size='small'
                />
              </Grid>
            </Grid>
          )}
          {jobType === JobTypes.Sourcing && (
            <Grid
              item
              xs={12}
              style={{
                display: 'flex',

                flexDirection: 'column'
              }}
            >
              {rejectionReasons?.map((item, index) =>
                item.isUserDefined ? (
                  <Grid
                    container
                    style={{
                      display: 'flex',
                      border: `1px solid ${theme.palette.border.main}`,
                      padding: '24px 16px',
                      marginTop: '24px'
                    }}
                  >
                    {/* <Grid item xs={12}>
                          <IconButton
                            size='16'
                            onClick={() => {
                              const reasons = [...rejectionReasons]
                              reasons.splice(index, 1)
                              setRejectionReasons(reasons)
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Grid> */}

                    <Grid item xs={6} style={{ display: 'none' }}>
                      <TextRegular
                        style={{
                          fontSize: '16px',
                          marginBottom: '6px',
                          color: theme.palette.text.secondary
                        }}
                      >
                        Reject reason
                      </TextRegular>

                      <TextField
                        size='small'
                        placeholder={'Please enter reject reason'}
                        onChange={e => {
                          const { value } = e.target
                          if (value.length < 5) {
                            const reasons = [...rejectionReasons]
                            reasons[index].reason = value
                            setRejectionReasons(reasons)
                          }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position='end'>
                              <IconButton
                                size='16'
                                onClick={() => {
                                  const reasons = [...rejectionReasons]
                                  reasons.splice(index, 1)
                                  setRejectionReasons(reasons)
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                        fullWidth
                        sx={{
                          minWidth: '20rem'
                        }}
                        error={
                          formError.hasOwnProperty('rejectionReasons')
                            ? formError?.rejectionReasons[index]?.reason
                            : false
                        }
                        helperText={
                          formError.hasOwnProperty('rejectionReasons')
                            ? formError?.rejectionReasons[index]?.reason
                            : ''
                        }
                      />
                    </Grid>
                    <Divider
                      fullWidth
                      style={{
                        width: '100%',
                        marginTop: '16px'
                      }}
                    />
                    <Grid item xs={12}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={item.addToLibrary}
                              onChange={() => {
                                const reasons = [...rejectionReasons]
                                reasons[index].addToLibrary = !item.addToLibrary
                                setRejectionReasons(reasons)
                              }}
                            />
                          }
                          label='Also add to library'
                          style={{ color: theme.palette.text.secondary }}
                        />
                      </FormGroup>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: 'flex',
                      marginRight: '16px'
                    }}
                  >
                    <Grid item xs={0.8}>
                      <FormGroup>
                        <FormControlLabel
                          style={{
                            margin: '0px',
                            color: theme.palette.text.secondary
                          }}
                          key={index}
                          control={
                            <Checkbox
                              checked={item.isChecked}
                              onChange={event => {
                                const { checked } = event.target
                                const reasons = [...rejectionReasons]
                                reasons[index].isChecked = checked
                                setRejectionReasons(reasons)
                              }}
                            />
                          }
                        />
                      </FormGroup>
                    </Grid>
                    <Grid
                      item
                      xs={9}
                      style={{
                        display: 'flex',
                        justifyContent: 'left',
                        alignItems: 'center',
                        color: theme.palette.text.secondary
                      }}
                    >
                      {item.reason}
                    </Grid>
                    <Grid
                      item
                      xs={0.8}
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer'
                      }}
                    >
                      <Button
                        style={{ textTransform: 'capitalize' }}
                        onClick={() => {
                          setEditRejection(item.reason)
                          setEditRejectionModal({ show: true, item, index })
                        }}
                      >
                        Edit
                      </Button>
                    </Grid>
                    <Divider
                      orientation='vertical'
                      variant='middle'
                      flexItem
                      style={{
                        margin: '7px 5px'
                      }}
                    />
                    <Grid
                      item
                      xs={0.8}
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer'
                      }}
                    >
                      <Button
                        style={{ textTransform: 'capitalize' }}
                        onClick={() => {
                          setViewRejection(item)
                        }}
                      >
                        View
                      </Button>
                    </Grid>
                    <Divider
                      orientation='vertical'
                      variant='middle'
                      flexItem
                      style={{
                        margin: '7px 5px'
                      }}
                    />
                    <Grid
                      item
                      xs={0.8}
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer'
                      }}
                    >
                      <Button
                        style={{ textTransform: 'capitalize' }}
                        onClick={() => {
                          const reasons = [...rejectionReasons]
                          reasons.splice(index, 1)
                          setRejectionReasons(reasons)
                        }}
                      >
                        Delete
                      </Button>
                    </Grid>
                  </Grid>
                )
              )}

              <Grid item xs={12} style={{ margin: '24px 0px' }}>
                <Button
                  variant='contained'
                  style={{
                    textTransform: 'none'
                  }}
                  onClick={() => {
                    setRejectionReasons(prev => [
                      ...prev,
                      {
                        reason: '',
                        isChecked: true,
                        isUserDefined: true,
                        addToLibrary: true
                      }
                    ])
                  }}
                >
                  Add a reject reason
                </Button>
              </Grid>

              <Grid
                item
                xs={6}
                style={{
                  display: 'flex',
                  fontWeight: 500,
                  flexDirection: 'column'
                }}
              >
                <div style={{ marginRight: '48px' }}>
                  <FormControl fullWidth>
                    <TextRegular
                      style={{
                        marginBottom: '6px',
                        color: theme.palette.text.secondary
                      }}
                    >
                      Reject button will expire in
                    </TextRegular>
                    <Select
                      required
                      id='rejectionPeriod'
                      value={rejectionPeriod}
                      onChange={e => setRejectionPeriod(e.target.value)}
                    >
                      <MenuItem required value={'1 business day'}>
                        1 business day
                      </MenuItem>
                      <MenuItem required value={'2 business day'}>
                        2 business day
                      </MenuItem>
                      <MenuItem required value={'3 business day'}>
                        3 business day
                      </MenuItem>
                      <MenuItem required value={'5 business day'}>
                        5 business day
                      </MenuItem>
                      <MenuItem required value={'7 business day'}>
                        7 business day
                      </MenuItem>
                      <MenuItem required value={'10 business day'}>
                        10 business day
                      </MenuItem>
                      <MenuItem required value={'Not applicable'}>
                        Not applicable
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </Grid>

              <Dialog
                open={editRejectionModal?.show}
                onClose={() => closeEditModal()}
                fullWidth
              >
                <DialogTitle>Edit rejection reason</DialogTitle>
                <DialogContent>
                  <TextField
                    placeholder='Rejection reason'
                    value={editRejection}
                    onChange={e => {
                      setEditRejection(e.target.value)
                    }}
                    sx={{
                      width: '100%',
                      marginTop: '10px'
                    }}
                    size='small'
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    style={{ textTransform: 'capitalize' }}
                    variant='contained'
                    onClick={() => closeEditModal()}
                  >
                    Cancel
                  </Button>
                  <Button
                    disabled={isEmpty(editRejection)}
                    style={{ textTransform: 'capitalize' }}
                    variant='contained'
                    onClick={() => {
                      const reasons = [...rejectionReasons]
                      reasons[editRejectionModal.index].reason = editRejection
                      setRejectionReasons(reasons)
                      closeEditModal()
                    }}
                  >
                    Save
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={viewRejection !== null}
                onClose={() => setViewRejection(null)}
                fullWidth
              >
                <DialogTitle style={{ color: `${theme.palette.text.primary}` }}>
                  View rejection reason
                </DialogTitle>
                <DialogContent
                  style={{ color: `${theme.palette.text.primary}` }}
                >
                  {viewRejection?.reason}
                </DialogContent>
                <DialogActions>
                  <Button
                    style={{ textTransform: 'capitalize' }}
                    variant='contained'
                    onClick={() => setViewRejection(null)}
                  >
                    Cancel
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
          )}
        </Grid>

        <Grid
          item
          xs={12}
          style={{ margin: '32px 0px 8px', paddingTop: '0px' }}
        >
          <Divider />
        </Grid>

        {/* <Grid item xs={6}>
              <FormControl fullWidth error={formError.educationLevel}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px'
                  }}
                >
                  Education Level *
                </TextRegular>
                <Select
                  required
                  id='educationLevel'
                  value={educationLevel}
                  onChange={e => setEducationLevel(e.target.value)}
                >
                  {dropDownValues?.educationLevel?.map(item => (
                    <MenuItem required value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{formError.educationLevel}</FormHelperText>
              </FormControl>
            </Grid> */}

        <Grid item xs={6}>
          <FormControl fullWidth error={formError.experienceLevel}>
            <TextRegular
              style={{
                color: theme.palette.text.secondary,
                marginBottom: '6px'
              }}
            >
              Experience Level *
            </TextRegular>
            <Select
              required
              id='experienceLevel'
              value={experienceLevel}
              onChange={e => setExperienceLevel(e.target.value)}
            >
              {dropDownValues?.experienceLevel?.map(item => (
                <MenuItem required value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{formError.experienceLevel}</FormHelperText>
          </FormControl>
        </Grid>
        {/* <Grid
              item
              xs={12}
              style={{ paddingLeft: '24px', marginBottom: '-42px' }}
            >
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px'
                }}
              >
                Required Experience *
              </TextRegular>
            </Grid> */}
        {/* <Grid item xs={3} style={{ display: 'flex', alignItems: 'end' }}>
              <FormControl fullWidth>
                <InputLabel id='Year'>Year *</InputLabel>
                <Select
                  required
                  id='Year'
                  label='Year'
                  value={requiredExpYear}
                  onChange={e => setRequiredExpYear(e.target.value)}
                >
                  {Array.from(Array(51).keys()).map(number => (
                    <MenuItem value={number}>{number}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} style={{ display: 'flex', alignItems: 'end' }}>
              <FormControl fullWidth>
                <InputLabel id='Months'>Months *</InputLabel>
                <Select
                  required
                  id='Months'
                  label='Months'
                  value={requiredExpMonth}
                  onChange={e => setRequiredExpMonth(e.target.value)}
                >
                  {Array.from(Array(12).keys()).map(number => (
                    <MenuItem value={number}>{number}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid> */}
        {/* Visa sponsorship eligibility 
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px'
                  }}
                >
                  Visa sponsorship eligibility *
                </TextRegular>
                <Select
                  required
                  id='visaSponsorship'
                  value={visaSponsorship}
                  onChange={e => setVisaSponsorship(e.target.value)}
                >
                  <MenuItem value={'yes'}>Yes</MenuItem>
                  <MenuItem value={'no'}>No</MenuItem>
                </Select>
              </FormControl>
            </Grid> */}

        <Grid
          item
          xs={12}
          style={{ margin: '32px 0px 8px', paddingTop: '0px' }}
        >
          <Divider />
        </Grid>

        <div
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            padding: '24px 0px 24px 24px'
          }}
        >
          <div style={{ width: '100%', margin: '0px' }}>
            <div
              maxWidth='lg'
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}
            >
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px'
                }}
              >
                Job Description *
              </TextRegular>
              <div>
                <FormControl fullWidth error={formError.jobDescription}>
                  <TextEditor
                    getter={jobDescription}
                    setter={setJobDescription}
                    placeholder={'Copy and paste the job description here.'}
                  />

                  <FormHelperText>{formError.jobDescription}</FormHelperText>
                </FormControl>
              </div>

              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px',
                  marginTop: '32px'
                }}
              >
                Skills *
              </TextRegular>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <FormControl fullWidth error={formError.skillRequired}>
                  <Box>
                    <TextField
                      placeholder='Press enter to enter multiple skills'
                      value={inputSkills}
                      onChange={event => {
                        const { value } = event.target
                        setInputSkills(value)
                        if (value) {
                          getSkillSuggestions(value)
                        }
                      }}
                      onKeyDownCapture={event => {
                        setPopperClick(true)
                        handleEnterSkills(event, event.target.value)
                      }}
                      InputProps={{
                        disableUnderline: true
                      }}
                      sx={{
                        width: '100%',
                        marginTop: '10px'
                      }}
                      ref={containerRef}
                      onFocus={() => {
                        setOpenPopper(true)
                        setPopperClick(true)
                      }}
                      onBlur={() => {
                        if (popperClick) {
                          setOpenPopper(true)
                        } else {
                          setOpenPopper(false)
                        }
                      }}
                    />
                    {skillRequired?.map((skill, index) => (
                      <Chip
                        key={index}
                        label={skill}
                        onDelete={() => handleDeleteSkill(index)}
                        style={{
                          margin: '2px'
                        }}
                        sx={{
                          '& .MuiChip-deleteIcon': {
                            color: `${theme.palette.primary.main}`
                          }
                        }}
                      />
                    ))}

                    <Popper
                      open={
                        skillSuggestions.length > 0 && openPopper && popperClick
                      }
                      anchorEl={containerRef.current}
                      placement='bottom-start'
                    >
                      <ClickAwayListener
                        onClickAway={event => {
                          if (!containerRef.current.contains(event.target)) {
                            setPopperClick(false)
                            setOpenPopper(false)
                          }
                        }}
                      >
                        <Paper
                          sx={{
                            padding: '0px',
                            width: containerRef?.current?.clientWidth
                          }}
                        >
                          <Grid container>
                            <Grid item xs={12}>
                              <ul
                                style={{
                                  listStyleType: 'none',
                                  padding: '0px',
                                  margin: '0px'
                                }}
                              >
                                {skillSuggestions.map((skill, index) => (
                                  <>
                                    <Button
                                      style={{
                                        color: theme.palette.text.secondary,
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'left',
                                        textTransform: 'none'
                                      }}
                                      onClick={event => {
                                        handleEnterSkills(
                                          event,
                                          skill.skill_name
                                        )
                                      }}
                                    >
                                      <li
                                        key={index}
                                        style={{
                                          padding: '10px',
                                          lineHeight: '1rem'
                                        }}
                                      >
                                        {skill.skill_name}
                                      </li>
                                    </Button>
                                    {index < skillSuggestions.length - 1 && (
                                      <Divider style={{ width: '100%' }} />
                                    )}
                                  </>
                                ))}
                              </ul>
                            </Grid>
                          </Grid>
                        </Paper>
                      </ClickAwayListener>
                    </Popper>
                  </Box>
                  <FormHelperText>{formError.skillRequired}</FormHelperText>
                </FormControl>
              </div>
            </div>
          </div>
        </div>

        {/* <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                justifyContent: 'left',
                paddingLeft: '24px',
                marginBottom: '24px'
              }}
            >
              <TextBold style={{ fontSize: '18px', lineHeight: '24px' }}>
                Pre-screen questionnaire
              </TextBold>
            </Grid> */}

        {/* {preScreenQuesJobType?.map((item, index) => (
              <Grid
                container
                style={{
                  display: 'flex',
                  margin: '12px 0px 24px 24px'
                }}
              >
                <Grid
                  key={index}
                  item
                  xs={12}
                  style={{
                    display: 'flex',
                    flexGrow: 1
                  }}
                >
                  <Grid
                    item
                    xs={6}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column'
                    }}
                  >
                    <div style={{ fontWeight: 500 }}>Question</div>

                    <TextField
                      key={index}
                      size='small'
                      placeholder={'Please enter a question'}
                      value={item.question}
                      onChange={e => {
                        const { value } = e.target
                        const questions = [...preScreenQuesJobType]
                        questions[index].question = value
                        setPreScreenQuesJobType(questions)
                      }}
                      sx={{
                        width: '100%',
                        marginTop: '10px'
                      }}
                      error={
                        formError.hasOwnProperty('preScreenQuesJobType')
                          ? formError?.preScreenQuesJobType[index]?.question
                          : false
                      }
                      helperText={
                        formError.hasOwnProperty('preScreenQuesJobType')
                          ? formError?.preScreenQuesJobType[index]?.question
                          : ''
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      marginLeft: '10px'
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 500,
                        marginBottom: '10px'
                      }}
                    >
                      Answer type
                    </div>
                    {item.isUserDefined ? (
                      <FormControl fullWidth>
                        <Select
                          required
                          id='anstype'
                          value={item.type}
                          onChange={e => {
                            var value = e.target.value
                            const questions = [...preScreenQuesJobType]
                            questions[index].type = value
                            if (value !== 'textfield') {
                              questions[index].options = [
                                { name: '', isQualify: true },
                                { name: '', isQualify: true }
                              ]
                            } else {
                              questions[index].options = []
                            }
                            setPreScreenQuesJobType(questions)
                          }}
                          size='small'
                          fullWidth
                        >
                          <MenuItem value={'textfield'}>Text Field</MenuItem>
                          <MenuItem value={'checkbox'}>Checkbox</MenuItem>
                          <MenuItem value={'dropdown'}>Drop Down</MenuItem>
                          <MenuItem value={'radio'}>Radio Button</MenuItem>
                        </Select>
                      </FormControl>
                    ) : (
                      <div style={{ textTransform: 'capitalize' }}>
                        {item.type}
                      </div>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-evenly',
                      alignItems: 'center'
                    }}
                  >
                    <Tooltip title='Delete'>
                      <IconButton
                        onClick={() => {
                          if (item.employerId) {
                            setModal({
                              open: true,
                              message:
                                'Do you want to delete this question from library also?',
                              onClose: () => {
                                setModal({ open: false })
                              },
                              positiveBtnText: 'Yes',
                              onClickPositiveButton: () => {
                                setModal({ open: false })
                                deleteQuestionFromLibrary(item, index)
                              },
                              negativeBtnText: 'No, only delete for now',
                              onClickNegativeButton: () => {
                                setModal({ open: false })
                                const questions = [...preScreenQuesJobType]
                                questions.splice(index, 1)
                                setPreScreenQuesJobType(questions)
                              }
                            })
                          } else {
                            const questions = [...preScreenQuesJobType]
                            questions.splice(index, 1)
                            setPreScreenQuesJobType(questions)
                          }
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                    {index > 0 ? (
                      <IconButton
                        onClick={() => {
                          const questions = [...preScreenQuesJobType]
                          questions[index] = questions[index - 1]
                          questions[index - 1] = item
                          setFormError({})
                          setPreScreenQuesJobType(questions)
                        }}
                      >
                        <ArrowUpwardIcon />
                      </IconButton>
                    ) : null}
                  </Grid>
                </Grid>

                {item.options.length > 0 && (
                  <Grid item xs={12}>
                    <Grid xs={12} container sx={{ mt: 2 }}>
                      <Grid xs={4} item>
                        <div>Answer Choices</div>
                      </Grid>
                      <Grid xs={2} item>
                        <IconButton
                          onClick={() => {
                            const questions = [...preScreenQuesJobType]

                            questions[index].options.push({
                              name: '',
                              isQualify: true
                            })

                            setPreScreenQuesJobType(questions)
                          }}
                          sx={{ ml: 2, fontSize: 14 }}
                        >
                          <AddIcon /> Add choice
                        </IconButton>
                      </Grid>
                    </Grid>

                    {item?.options?.map((option, optionIndex) => (
                      <Grid item xs={12} container sx={{ mt: 2 }}>
                        <Grid item xs={4}>
                          <TextField
                            label={`Option ${optionIndex + 1}`}
                            variant='outlined'
                            value={option.name}
                            onChange={e => {
                              const questions = [...preScreenQuesJobType]
                              questions[index].options[optionIndex].name =
                                e.target.value
                              setPreScreenQuesJobType(questions)
                            }}
                            fullWidth
                            sx={{
                              width: '100%'
                            }}
                            size='small'
                            error={
                              formError.hasOwnProperty(
                                'preScreenQuesJobType'
                              ) &&
                              formError?.preScreenQuesJobType.hasOwnProperty(
                                index
                              ) &&
                              formError.preScreenQuesJobType[
                                index
                              ].hasOwnProperty('options')
                                ? formError?.preScreenQuesJobType[index]
                                    ?.options[optionIndex]
                                : false
                            }
                            helperText={
                              formError.hasOwnProperty(
                                'preScreenQuesJobType'
                              ) &&
                              formError?.preScreenQuesJobType.hasOwnProperty(
                                index
                              ) &&
                              formError.preScreenQuesJobType[
                                index
                              ].hasOwnProperty('options')
                                ? formError?.preScreenQuesJobType[index]
                                    ?.options[optionIndex]
                                : ''
                            }
                          />
                        </Grid>
                        <Grid item xs={2} sx={{ ml: 1 }}>
                          <Select
                            required
                            id='anstype'
                            value={option.isQualify}
                            onChange={e => {
                              const questions = [...preScreenQuesJobType]
                              questions[index].options[optionIndex].isQualify =
                                e.target.value
                              setPreScreenQuesJobType(questions)
                            }}
                            size='small'
                            fullWidth
                          >
                            <MenuItem value={true}>Qualify</MenuItem>
                            <MenuItem value={false}>Disqualify</MenuItem>
                          </Select>
                        </Grid>
                        {optionIndex > 1 && (
                          <IconButton
                            onClick={() => {
                              const questions = [...preScreenQuesJobType]
                              questions[index].options.splice(optionIndex, 1)

                              setPreScreenQuesJobType(questions)
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </Grid>
                    ))}
                  </Grid>
                )}

                {item.isUserDefined && (
                  <>
                    <Grid item xs={4}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={item.addToLibrary}
                              onChange={() => {
                                const questions = [...preScreenQuesJobType]
                                questions[index].addToLibrary =
                                  !item.addToLibrary
                                setPreScreenQuesJobType(questions)
                              }}
                            />
                          }
                          label='Also add to question library'
                        />
                      </FormGroup>
                    </Grid>

                    <Grid item xs={4}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={item.isRequired}
                              onChange={() => {
                                const questions = [...preScreenQuesJobType]
                                questions[index].isRequired = !item.isRequired
                                setPreScreenQuesJobType(questions)
                              }}
                            />
                          }
                          label='Required to be answered*'
                        />
                      </FormGroup>
                    </Grid>
                  </>
                )}
                <Divider
                  fullWidth
                  style={{
                    width: '100%',

                    marginTop: '24px'
                  }}
                />
              </Grid>
            ))} */}

        {/* <Grid item xs={12}>
              <Button
                variant='contained'
                style={{ textTransform: 'none' }}
                onClick={() => {
                  setPreScreenQuesJobType(prev => [
                    ...prev,
                    {
                      question: '',
                      type: 'textfield',
                      options: [],
                      isRequired: true,
                      isUserDefined: true,
                      addToLibrary: true
                    }
                  ])
                }}
              >
                Add another question
              </Button>
            </Grid> */}

        {/* Assign job to a team member: */}

        {/* Job email send*/}
        <Grid item xs={12} style={{ display: 'none' }}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={emailShow}
                  onChange={() => setEmailShow(!emailShow)}
                />
              }
              style={{ color: theme.palette.text.secondary }}
              label='Send email notifications to different email.'
            />
          </FormGroup>
        </Grid>

        {emailShow === true && (
          <Grid item xs={6} style={{ display: 'flex', margin: '0px 1px' }}>
            <FormControl fullWidth error={formError.emailCc}>
              <Box
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  padding: '5px',
                  border: `1px solid ${theme.palette.border.main}`,
                  borderRadius: '5px',
                  width: '100%'
                }}
              >
                {emailCc?.map((email, index) => (
                  <Chip
                    key={index}
                    label={email}
                    onDelete={() => {
                      var emails = [...emailCc]
                      emails.splice(index, 1)
                      setEmailCc(emails)
                    }}
                    style={{
                      margin: '2px'
                    }}
                    sx={{
                      '& .MuiChip-deleteIcon': {
                        color: theme.palette.primary.main
                      }
                    }}
                  />
                ))}

                <TextField
                  placeholder='Press enter to add multiple emails'
                  value={inputEmail}
                  onChange={e => setInputEmail(e.target.value)}
                  onKeyDownCapture={event => {
                    const email = inputEmail.trim()
                    if (event.key === 'Enter' && !isEmpty(email)) {
                      if (validateEmail(email)) {
                        if (emailCc.includes(email)) {
                          showToast('Email already added')
                        } else {
                          setEmailCc([...emailCc, email])
                          setInputEmail('')
                        }
                      } else {
                        showToast('Please enter a valid email address')
                      }
                    }
                  }}
                  InputProps={{
                    disableUnderline: true
                  }}
                  sx={{
                    width: '100%',
                    marginTop: '10px'
                  }}
                />
                <FormHelperText>{formError.emailCc}</FormHelperText>
              </Box>
            </FormControl>
          </Grid>
        )}

        {/* <Grid item xs={6}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px'
                }}
              >
                Your organization's job order number *
              </TextRegular>
              <TextField
                variant='outlined'
                value={jobOrderNumber}
                onChange={e => {
                  setJobOrderNumber(e.target.value)
                }}
                fullWidth
                sx={{
                  width: '100%'
                }}
              />
            </Grid> */}

        <Grid
          item
          xs={12}
          style={{ margin: '32px 0px 8px 0px', paddingTop: '0px' }}
        >
          <Divider />
        </Grid>

        {/* Buttons*/}
        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row', padding: '0px' }}
        >
          {!data?.isEdit ? (
            <div style={{ paddingLeft: '16px', display: 'flex' }}>
              <Grid style={{ margin: '10px' }}>
                <AppButton
                  variant='contained'
                  name={'Save as draft'}
                  style={{ width: 'fit-content' }}
                  disabled={false}
                  loading={jobDraftLoading}
                  onClick={() => handleSubmitJob(true)}
                />
              </Grid>

              <Grid style={{ margin: '10px' }}>
                <AppButton
                  variant='contained'
                  name={'Save and post'}
                  style={{ width: 'fit-content' }}
                  disabled={false}
                  loading={jobPostLoading}
                  onClick={() => handleSubmitJob(false)}
                />
              </Grid>
            </div>
          ) : (
            <>
              <Grid style={{ margin: '10px' }}>
                <AppButton
                  variant='contained'
                  name={'Update'}
                  disabled={false}
                  loading={jobUpdateLoading}
                  onClick={() => handleSubmitJob()}
                />
              </Grid>
              <Grid style={{ margin: '10px' }}>
                <Button
                  variant='contained'
                  style={{ textTransform: 'none' }}
                  onClick={() => {
                    navigate('/employer/managejob')
                  }}
                >
                  Go Back
                </Button>
              </Grid>
            </>
          )}

          <Grid style={{ margin: '10px' }}>
            <Button
              variant='contained'
              style={{ textTransform: 'none' }}
              onClick={() => {
                if (validateForm()) {
                  setPreviewModal({
                    open: true,
                    company: user.companyname,
                    jobDescription: jobDescription,
                    title: jobTitle,
                    type: dropDownValues?.jobTypes?.find(e => e.id === jobType)
                      ?.name,
                    jobFunction: dropDownValues?.jobFunctions?.find(
                      e => e.id === jobFunction
                    )?.name,

                    experienceLevel: dropDownValues?.experienceLevel?.find(
                      e => e.id === experienceLevel
                    )?.name,
                    // education: dropDownValues?.educationLevel?.find(
                    //   e => e.id === educationLevel
                    // )?.name,
                    compensationFrom: jobCompensationAmountMin,
                    compensationTo: jobCompensationAmountMax,
                    // state: state,
                    // country: country,
                    // zipCode: zipCode,
                    skill: skillRequired.join(', '),
                    experienceYears: requiredExpYear,
                    experienceMonths: requiredExpMonth,
                    onClose: () => {
                      setPreviewModal({
                        open: false
                      })
                    }
                  })
                }
              }}
            >
              Preview
            </Button>
          </Grid>
          <Grid style={{ margin: '10px' }}>
            <Button
              variant='outlined'
              style={{ textTransform: 'none' }}
              onClick={() => {
                navigate('/employer/managejob')
              }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Grid>

      {modal.open && <CustomModal data={modal} />}
      {previewModal.open && <JobPostPreviewModal data={previewModal} />}
    </Grid>
  )
}
